import { ModalProps } from "antd/lib/modal/Modal";
import { InputNumber, message, Modal, Spin } from "antd";
import Style from "./index.module.scss";
import React from "react";
import Form, { useForm } from "rc-field-form";
import FieldWithErrorHaveLabel from "../../../../../components/FieldWithErrorHaveLabel";

import useRequestFn from "../../../../../utils/useRequestFn";
import { ResultMessage } from "../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../service/service";
import { updateExamStuScore } from "../../../../../service/exam";

interface Props extends ModalProps {
    onSuccess: () => void;
    examid: string;
    studentid: string;
    paperid: string;
    score: number;
}

interface FormProp {
    score: number;
}

const Index = ({
    examid,
    studentid,
    onSuccess,
    paperid,
    score,
    ...props
}: Props) => {
    const [form] = useForm<FormProp>();

    const [saveAction, { loading: saveLoading }] =
        useRequestFn(updateExamStuScore);

    async function onFinish(data: FormProp) {
        try {
            await saveAction({
                examid,
                studentid,
                paperid,
                ...data
            });
            await onSuccess();
            message.success("修改成功");
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            okButtonProps={{ loading: saveLoading }}
            width={600}
            title="修改分数"
            onOk={form.submit}>
            <Spin spinning={[].some(i => i)}>
                <div className={Style.root}>
                    <Form form={form} onFinish={onFinish}>
                        <FieldWithErrorHaveLabel
                            initialValue={score}
                            require
                            rules={[
                                {
                                    required: true,
                                    message: "请填写分数"
                                }
                            ]}
                            label="分数："
                            name="score">
                            <InputNumber maxLength={1000} min={0} step={0.1} />
                        </FieldWithErrorHaveLabel>
                    </Form>
                </div>
            </Spin>
        </Modal>
    );
};
export default Index;
